<template>
	<div style="margin-top: 30px;">
		<div class="box_header"><span>{{$t('DataRecycling.Filter')}}</span></div>
		<div class="filtrateBox">
			<div class="filtrateMain">
				<div class="main_condition">
					{{$t('DataRecycling.FilterMeetsTheFollowingCriteria')}}
					<el-select class="select" size="medium" v-model="filtrate.type" :placeholder="$t('DataRecycling.PleaseSelect')" :popper-append-to-body="false">
						<el-option v-for="item in conditionList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>

					{{$t('DataRecycling.Data')}}
				</div>
				<div>
					<div class="main_topic">
						<div class="topicTitle">{{$t('DataRecycling.AnswerToTheQuestion')}}</div>
						<div class="topicBox">
							<div v-for="(item, index) in filtrate.innerSCreeings" :key="item.value">
								<div class="topic" v-if="item.type == 1">
									<!-- 题目 -->
									<el-select class="select" size="medium" v-model="item.qid" :placeholder="$t('DataRecycling.PleaseSelect')"
										@change="getOption(value, item, index)" :popper-append-to-body="false">
										<el-option v-for="titleitem in titleList" :key="titleitem.qid"
											:label="titleitem.quesIndex + 1 + titleitem.questionsName"
											:value="titleitem.qid"></el-option>
									</el-select>
									<!-- 条件 -->
									<el-select class="select condition" size="medium" v-model="item.way" :placeholder="$t('DataRecycling.PleaseSelect')" v-if="item.qtype == 8 || item.qtype == 10 || item.qtype == 12 || item.qtype == 6" :popper-append-to-body="false">
										<el-option v-for="topicConditionitem in topicConditionList"
											:key="topicConditionitem.value" :label="topicConditionitem.label"
											:value="topicConditionitem.value"></el-option>
									</el-select>
									<el-select class="select condition" size="medium" v-model="item.way" :placeholder="$t('DataRecycling.PleaseSelect')" v-else :popper-append-to-body="false">
										<el-option v-for="topicConditionitem in topicConditionMultipleList"
											:key="topicConditionitem.value" :label="topicConditionitem.label"
											:value="topicConditionitem.value"></el-option>
									</el-select>
									<!-- 选项 -->
									<el-select class="select" size="medium" v-model="item.answer" :placeholder="$t('DataRecycling.PleaseSelect')"
										v-if="(item.way != 5 && item.way != 4) && (item.qtype == 8 || item.qtype == 10 || item.qtype == 12 || item.qtype == 6)" :multiple="item.qtype == 10" :popper-append-to-body="false">
										<el-option v-for="(optionitem, optionindex) in item.optionList"
											:key="optionindex" :label="optionitem.labelName" :value="optionitem.oid">
										</el-option>
									</el-select>
									<el-input style="width: 200px" size="medium" v-else v-model="item.answer"></el-input>
									<el-button v-if="index != 0" size="medium" @click="dleFiltrate(index)">{{$t('DataRecycling.Delete')}}</el-button>
								</div>
								<!-- 集合 -->
								<div class="setstopic" v-if="item.type == 2">
									<div class="setstopic_top">
										{{$t('DataRecycling.ShowSatisfaction')}}
										<el-select class="select" size="medium" v-model="item.type" :placeholder="$t('DataRecycling.PleaseSelect')" :popper-append-to-body="false">
											<el-option v-for="item in conditionList" :key="item.value"
												:label="item.label" :value="item.value"></el-option>
										</el-select>
										{{$t('DataRecycling.AnswerSheet')}}
										<el-button size="medium" @click="dleFiltrate(index)" style="float: right;">{{$t('DataRecycling.Delete')}}</el-button>
									</div>
									<div class="topCond" v-for="(inItem, inIndex) in item.conditionList" :key="inIndex">
										<!-- 选项 -->
										<el-select class="select" size="medium" v-model="inItem.qid" :placeholder="$t('DataRecycling.PleaseSelect')"
											@change="getOption(value, inItem, inIndex)" :popper-append-to-body="false">
											<el-option v-for="titleitem in titleList" :key="titleitem.qid"
												:label="titleitem.quesIndex + 1 + titleitem.questionsName"
												:value="titleitem.qid"></el-option>
										</el-select>
										<!-- 条件 -->
										<el-select class="select" size="medium" v-model="inItem.way" :placeholder="$t('DataRecycling.PleaseSelect')" v-if="inItem.qtype == 8" :popper-append-to-body="false">
											<el-option v-for="topicConditionitem in topicConditionList"
												:key="topicConditionitem.value" :label="topicConditionitem.label"
												:value="topicConditionitem.value"></el-option>
										</el-select>
										<el-select class="select" size="medium" v-model="inItem.way" :placeholder="$t('DataRecycling.PleaseSelect')" v-else :popper-append-to-body="false">
											<el-option v-for="topicConditionitem in topicConditionMultipleList"
												:key="topicConditionitem.value" :label="topicConditionitem.label"
												:value="topicConditionitem.value"></el-option>
										</el-select>
										<!-- 选项 -->
										<el-select class="select" size="medium" v-model="inItem.answer" :placeholder="$t('DataRecycling.PleaseSelect')"
											v-if="inItem.way != 5 && inItem.way != 4" :multiple="inItem.qtype == 10" :popper-append-to-body="false">
											<el-option v-for="(optionitem, optionindex) in inItem.optionList"
												:key="optionindex" :label="optionitem.labelName"
												:value="optionitem.oid"></el-option>
										</el-select>
										<i @click="delOption(item, inIndex)" v-show="inIndex != 0"
											class="el-icon-minus"></i>
										<i @click="addOption(item, index)" class="el-icon-plus"></i>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="topicmain_btn">
						<el-button size="medium" @click="addFiltrate">{{$t('DataRecycling.AddFilterCriteria')}}</el-button>
					</div>
				</div>
				<div class="main_time">
					<span class="time_title">{{$t('DataRecycling.AnswerDate')}}</span>
					<el-select class="select" size="medium" v-model="filtrate.time" :placeholder="$t('DataRecycling.PleaseSelect')" :popper-append-to-body="false">
						<el-option v-for="itme in timeList" :key="itme.value" :label="itme.label" :value="itme.value">
						</el-option>
					</el-select>
					<span class="time_block" v-if="filtrate.time == 2">
						<el-date-picker size="medium" v-model="filtrate.timeValue" type="datetimerange" :range-separator="$t('DataRecycling.To')"
							:start-placeholder="$t('DataRecycling.StartDate')" :end-placeholder="$t('DataRecycling.EndDate')"></el-date-picker>
					</span>
				</div>
			</div>
			<div class="btn">
				<el-button size="medium" @click="resetFiltrate">{{$t('DataRecycling.Clear')}}</el-button>
				<el-button size="medium" @click="loadDataFiltrate">{{$t('DataRecycling.Filter')}}</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	module.exports = {
		data: function() {
			return {
				filtrate: {
					// 筛选符合条件数据 1 全部 2任意
					type: '1',
					innerSCreeings: [{
						qid: '',
						way: '',
						answer: '',
						// 选项
						optionList: [],
						type: 1
					}],
					time: '',
					timeValue: ''
				},
				// 条件
				conditionList: [{
						value: '1',
						label: this.$t('DataRecycling.AllConditions')
					},
					{
						value: '2',
						label: this.$t('DataRecycling.AnyCondition')
					}
				],
				// 时间
				timeList: [{
						value: '1',
						label: this.$t('DataRecycling.All')
					},
					{
						value: '2',
						label: this.$t('DataRecycling.Custom')
					}
				],
				topicConditionList: [{
						value: '2',
						label: this.$t('DataRecycling.Selected')
					},
					{
						value: '3',
						label: this.$t('DataRecycling.NotSelected')
					},
					{
						value: '4',
						label: this.$t('DataRecycling.IsEmpty')
					},
					{
						value: '5',
						label: this.$t('DataRecycling.NotEmpty')
					}
				],
				topicConditionMultipleList: [{
						value: '0',
						label: this.$t('DataRecycling.Contain')
					},
					{
						value: '1',
						label: this.$t('DataRecycling.NotIncluded')
					},
					{
						value: '2',
						label: this.$t('DataRecycling.OnlySelect')
					},
					{
						value: '3',
						label: this.$t('DataRecycling.NotSelected')
					},
					{
						value: '4',
						label: this.$t('DataRecycling.IsEmpty')
					},
					{
						value: '5',
						label: this.$t('DataRecycling.NotEmpty')
					}
				],
				// 题目选项
				titleList: [],
				// 问卷
				projectId: '',
				token: ''
			};
		},
		props: {
			querytype: {
				type: String //可指定接收类型，如:Array.
			}
		},
		activated() {
			this.projectId = sessionStorage.getItem('wid') || this.$route.query.wid || 0;
			this.AllLoadData();
		},
		mounted() {
			this.projectId = sessionStorage.getItem('wid') || this.$route.query.wid || 0;

			this.AllLoadData();
		},
		methods: {
			loadDataFiltrate() {
				let that = this;
				let jsonCondition = that.filtrate;
				let json = JSON.stringify(jsonCondition);
				this.$emit('loadfiltrate', json);
			},
			reset() {
				let filtrate = {
					// 筛选符合条件数据 1 全部 2任意
					type: '',
					innerSCreeings: [{
						qid: '',
						way: '',
						answer: '',
						// 选项
						optionList: [],
						type: 1
					}],
					time: '',
					timeValue: ''
				};
				let Token = this.token;
				let that = this;
				that.filtrate = filtrate;
				that.loadDataFiltrate()
				// let params = {
				// 	that: this,
				// 	url: that.$config.service.removeScreeningCOndition,
				// 	data: {
				// 		prCode: that.projectId,
				// 		queryType: that.querytype
				// 	},
				// 	method: "POST",
				// 	cb(res) {
				// 		if (res.code == 0) {
				// 			that.filtrate = filtrate;
				// 			that.$message({
				// 				type: 'success',
				// 				message: '清空成功!'
				// 			});
				// 		}
				// 	},
				// };
				// this.$util.request(params);
			},
			// 清空
			resetFiltrate() {
				let _this = this;
				this.$alert(this.$t('DataRecycling.RestoreToDefault'), `${this.$t('DataRecycling.ConfirmEmptying')}？`, {
					confirmButtonText: this.$t('main.ok'),
					callback: action => {
						_this.reset();
					}
				});
			},
			// 保存
			subFiltrate() {
				let Token = this.token;
				let that = this;
				let jsonCondition = that.filtrate;
				let json = JSON.stringify(jsonCondition);
				console.log(json);

				let data = {
					prCode: that.projectId,
					jsonCondition: json,
					queryType: that.querytype
				};
				data = Qs.stringify(data);
				axios
					.post(serverurl + '/api/projectSample/saveScreeningCondition.servlet', data, {
						headers: {
							Authorization: Token
							// 'Content-Type': 'application/json;charset=UTF-8'
						}
					})
					.then(function(response) {
						if (response.data.result == '111111111111') {
							that.$message({
								showClose: true,
								message: response.data.msg,
								type: 'success'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
						alert(that.$t('DataRecycling.LoadError'));
						//that.loadData()
					});
			},
			delOption(item, index) {
				item.conditionList.splice(index, 1);
			},
			addOption(item, index) {
				console.log(item, index);
				let obj = {
					qid: '',
					way: '',
					answer: '',
					qtype: '',
					optionList: []
				};
				item.conditionList.push(obj);
			},
			getOption(value, item, index) {
				console.log(value, item, index);
				// 选择新题 清空之前选项
				item.answer = '';
				item.qtype = '';

				this.titleList.forEach(eve => {
					console.log(item.qid, eve.qid);
					if (item.qid == eve.qid) {
						console.log(eve);
						this.optionList = eve.optionList;
						item.qtype = eve.questionsTypeId;
						item.optionList = eve.optionList;
					}
				});
			},
			dleFiltrate(index) {
				console.log(index);
				this.filtrate.innerSCreeings.splice(index, 1);
			},
			addFiltrate() {
				let obj = {
					qid: '',
					way: '',
					answer: '',
					qtype: '',
					optionList: [],
					type: 1
				};
				this.filtrate.innerSCreeings.push(obj);
			},
			addSets() {
				let obj = {
					qid: '',
					way: '',
					answer: '',
					optionList: [],
					qtype: '',
					type: 2,
					conditionList: [{
						qid: '',
						way: '',
						answer: '',
						qtype: '',
						optionList: []
					}]
				};
				this.filtrate.innerSCreeings.push(obj);
			},
			getLoadData() {
				let Token = this.token;
				let that = this;
				axios
					.get(serverurl + '/api/projectSample/findScreeningCOndition.servlet', {
						params: {
							prCode: that.projectId,
							queryType: that.querytype
						},
						headers: {
							Authorization: Token,
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					})
					.then(function(response) {
						if (response.data.result == '111111111111') {
							if (response.data.data != '') {
								console.log(response.data.data);
								that.filtrate = JSON.parse(response.data.data.jsonCondition);
							}
						}
					})
					.catch(function(error) {
						console.log(error);
						alert(that.$t('DataRecycling.LoadError'));
						//that.loadData()
					});
			},
			htmlToString(htmlStr) {
				return htmlStr.replace(/<\/?.+?\/?>|\r|\n|\s*/g, '')
			},
			AllLoadData() {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.questionlist}?id=${that.projectId}`,
					method: 'GET',
					data: {},
					cb(res) {
						if (res.code == 0) {
							let titleList = JSON.parse(res.resultBody.tbExamPaper.paperjson).questionsList;
							titleList.forEach((item, index) => {
								if (item.questionsTypeId == 26) {
									titleList.splice(index, 1)
								}
							})
							titleList.forEach((item, index) => {
								if (item.questionsName != '') {
									item.questionsName = that.htmlToString(item.questionsName)
								}
							})

							that.titleList = titleList
							console.log('42141241', that.titleList);
						} else {
							that.titleList = [];
						}
					}
				};
				this.$util.request(params);

				// let Token = this.token;
				// let that = this;
				// axios
				// 	.get(serverurl + '/api/v1/questions/queryonequestionsoption', {
				// 		params: {
				// 			prCode: that.projectId
				// 		},
				// 		headers: {
				// 			Authorization: Token,
				// 			'Content-Type': 'application/x-www-form-urlencoded'
				// 		}
				// 	})
				// 	.then(function(response) {
				// 		that.titleList = response.data.data;
				// 	})
				// 	.catch(function(error) {
				// 		console.log(error);
				// 		alert('加载错误');
				// 		//that.loadData()
				// 	});
			}
		}
	};
</script>

<style scoped lang="scss">
	.select {
		margin-right: 10px;
	}
	.condition{
		/deep/.el-input__inner{
			width: 120px !important;
		}
	}
	.box_header {
		/* padding-bottom: 10px; */
		font-size: 18px;
	}

	.filtrateBox {
		background-color: #ffffff;
		padding: 20px;
		margin-top: 20px;
		font-size: 15px;
	}

	.filtrateMain {
		margin-top: 10px;
	}

	.main_condition {
		margin-bottom: 20px;
	}

	.main_topic {
		line-height: 40px;
		display: flex;
	}

	.topicTitle {
		margin-right: 20px;
	}

	.topic {
		margin-bottom: 10px;
	}

	.setstopic {
		/* background: #f7f8fa; */
		padding: 12px;
		margin: 6px 0 6px;
		box-sizing: border-box;
	}

	.setstopic_top {
		margin-bottom: 10px;
	}

	.topCond {
		margin-bottom: 10px;
	}

	.topicmain_btn {
		margin-left: 80px;
	}

	.main_time {
		margin-top: 20px;
	}

	.time_title {
		margin-right: 20px;
	}

	.time_block {
		margin-left: 10px;
	}

	.btn {
		border-top: 1px solid #cccccc;
		text-align: right;
		margin-top: 10px;
		padding-top: 10px;
	}
</style>
